var config = {
  serverurl: 'https://api.getflair.io/api/',
};

export default config;
